import useSearchLabel from "../../hooks/useSearchLabel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import LoadingSpinner from "~/ui/LoadingSpinner/LoadingSpinner";

interface KeywordInputProps {
    isLoading: boolean;
    isSearchEnabled: boolean;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleSearch: () => void;
}

const KeywordInput = (props: KeywordInputProps) => {
    const { isLoading, isSearchEnabled, handleInputChange, handleSearch } = props;
    const { textLabel } = useSearchLabel();
    const placeholder = textLabel ?? "";
    const btnClass = !isSearchEnabled ? "opacity-50" : "";

    const icon = isLoading ? (
        <LoadingSpinner className="text-caramel-vibrant" />
    ) : (
        <MagnifyingGlassIcon className="w-6 h-6 text-caramel-vibrant" />
    );

    return (
        <div className="flex flex-1 justify-between items-center gap-3">
            <input
                placeholder={placeholder}
                className="outline-none flex-1"
                onChange={handleInputChange}
            />
            <button onClick={handleSearch} disabled={!isSearchEnabled} className={btnClass}>
                {icon}
            </button>
        </div>
    );
};

export default KeywordInput;
